/** The email frame and its side panel. */
export default {
  // Frame
  toLabel: "To:",
  subjectLabel: "Subject:",
  noRecipient: "No recipient",
  noSubject: "No subject",
  noContent: "No content yet",
  streamingCursor: "Streaming cursor",
  saveDraft: "Save draft",
  send: "Send",
  requesting: "Requesting…",
  askSaveDraft: "Ask the creating agent to save this email as a draft",
  askSend: "Ask the creating agent to send this email",
  saveEditsFailed: "Couldn’t save email edits",
  addRecipientSubject: "Add a recipient and subject",
  sendRequested: "Send requested",
  draftSaveRequested: "Draft save requested",
  agentWillReport: "The agent will report the result in the conversation.",

  // Side panel
  panelTitle: "Email",
  closePanel: "Close panel",
  to: "To",
  subject: "Subject",
  recipientPlaceholder: "recipient@example.com",
  subjectPlaceholder: "Email subject",
  body: "Body",
  editBody: "Edit body",
  noBody: "No body content",
} as const;
